import CancelButton from '@/features/common/buttons/CancelButton'
import ConfirmButton from '@/features/common/buttons/ConfirmButton'
import { Actions } from '@/features/pos/components/OrderFinalization/parts/ActionConfirmationModal/types'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const ActionButtons: FC<Actions> = ({ onConfirm, onCancel }) => {
    const [isConfirmLoading, setIsConfirmLoading] = useState(false)

    const { t } = useTranslation()

    const handleConfirm = async () => {
        try {
            setIsConfirmLoading(true)

            await onConfirm()
        } finally {
            setIsConfirmLoading(false)
        }
    }

    return (
        <View style={styles.container}>
            <ConfirmButton
                onConfirm={handleConfirm}
                label={t('actions.yes')}
                loading={isConfirmLoading}
                testID="confirm-button"
            />
            <CancelButton onPress={onCancel} label={t('actions.no')} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignSelf: 'stretch',
        gap: 16,
    },
})

export default ActionButtons
